import React from 'react'
import qs from 'qs'

const withQS = function(WrappedComponent) {
  return (props) => {
    const QS = qs.parse(props.history.location.search.slice(1))
    return (
      <WrappedComponent qs={QS} {...props}/>
    )
  }
}

export default withQS


// WEBPACK FOOTER //
// ./src/wrappers/QSWrapper.js